import React from 'react';
import { Button, Modal, ModalBody, FormGroup } from 'reactstrap';

// The shared-phone question for a guard, supervisor or client form (utils/people sharedPhoneState):
// - person given (the phone number belongs to someone of another kind): "Are Jo Smith (the supervisor you
//   are editing) and Test01 Guard01 (guard) the same person?", with what each answer does under it (details),
//   and "Yes, the same person" (onYes(person): saved with that person's CID), "No, different people" (onNo)
//   and Cancel;
// - otherwise "The phone number ... is also saved on ... Save it for this guard too?" with Cancel and
//   "Yes, save it" (onYes(null)).
// The form resends the save in onYes / onNo (confirmedSharedPhoneRequest).
export default function SharedPhoneModal({ isOpen, message, details, person, onYes, onNo, onCancel }) {
	const asksSamePerson = !!(person && onNo);
	const button = { minWidth: '100px', margin: '4px' };
	return (
		<Modal isOpen={isOpen} toggle={onCancel}>
			<ModalBody className="alert-body">
				<i className="mdi mdi-alert-circle ft-60"></i>
				<h4>{message}</h4>
				{asksSamePerson && Array.isArray(details) && details.length ? (
					<div style={{ textAlign: 'left', margin: '10px 0' }}>
						{details.map((line) => <div key={line}>{line}</div>)}
					</div>
				) : null}
				<div className="height-10"></div>
				<FormGroup>
					<Button color="secondary" style={button} onClick={onCancel}>Cancel</Button>
					{asksSamePerson ? <Button color="secondary" style={button} onClick={() => onNo()}>No, different people</Button> : null}
					<Button color="primary" style={button} onClick={() => onYes(asksSamePerson ? person : null)}>
						{asksSamePerson ? 'Yes, the same person' : 'Yes, save it'}
					</Button>
				</FormGroup>
			</ModalBody>
		</Modal>
	);
}
